<mat-card>
  <mat-card-content>

    <mat-form-field [style.width.%]="100">
      <mat-label>Sök</mat-label>
      <input [formControl]="filterControl" matInput name="filterRequests">
    </mat-form-field>

    <table [dataSource]="items"
           [style.margin-top.rem]="1.5"
           mat-table matSort>
      <caption>Lista över bankid</caption>

      <ng-container matColumnDef="personNummer">
        <th *matHeaderCellDef mat-header-cell
            mat-sort-header> Spärrad
        </th>
        <td *matCellDef="let item" mat-cell> {{ item.personNummer }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sub">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          Påbörjad av
        </th>
        <td *matCellDef="let item" mat-cell> {{ item.sub }}</td>
      </ng-container>

      <ng-container matColumnDef="consumed">
        <th *matHeaderCellDef mat-header-cell
            mat-sort-header=> Slutförd av
        </th>
        <td *matCellDef="let item" mat-cell> {{ item.consumed }}</td>
      </ng-container>

      <ng-container matColumnDef="timeStamp">
        <th *matHeaderCellDef mat-header-cell
            mat-sort-header> Datum
        </th>
        <td *matCellDef="let item" mat-cell>
          {{ item.timeStamp | date: 'yyyy-MM-dd' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="documentation">
        <th *matHeaderCellDef mat-header-cell> Detaljer
        </th>
        <td *matCellDef="let item" mat-cell>
          <button (click)="openDialog(item.documentation)" mat-icon-button>
            <mat-icon matTooltip="Detaljer">bookmark_border</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="columns()" mat-header-row></tr>
      <tr *matRowDef="let item; columns: columns()" mat-row></tr>

      <tr *matNoDataRow>
        <td [attr.colspan]="columns().length" class="no-data-cell">

          @if (filterControl.value) {
            <span>Din sökning gav inga träffar. Prova att ändra ditt filter.</span>
          } @else {
            <span>Laddar...</span>
          }
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>